import React from "react"
import "./TabButton.css"
import { TimerOffOutlined } from "@mui/icons-material"
export default function ({ text, active, onClick, disabled, addNew, expired }) {
  // console.log(pathName);
  // to be used in CollegeContainer - WIP
  return (
    <div
      className={
        "tabButtonVertical" +
        (active ? " tabButtonVerticalActive" : "") +
        (disabled ? " tabButtonDisabled" : "") +
        (addNew ? " tabButtonVerticalNew" : "")
      }
      onClick={onClick}
    >
      {expired ? <TimerOffOutlined className="mx-2" /> : null}
      <span className="tabButtonVerticalLabel">{text}</span>
    </div>
  )
}
